import React, { useCallback } from 'react';
import classnames from 'classnames';
import YoutubeVideoResourceRecord from '../../data/YoutubeVideoResourceRecord';
import VideoDuration from './VideoDuration';
import './YoutubeVideoListItem.pcss';

interface YoutubeVideoListItemProps {
  video: YoutubeVideoResourceRecord;
  isActive: boolean;
  onClick: (videoId: string) => void;
}

const YoutubeVideoListItem: React.FC<YoutubeVideoListItemProps> = ({
  video,
  onClick,
  isActive,
}) => {
  const onClickHandler = useCallback(
    e => {
      e.preventDefault();
      onClick(video.getVideoId());
    },
    [onClick, video]
  );

  return (
    <div className={classnames('YoutubeVideoListItem', { active: isActive })}>
      <a
        className="no-underline"
        href={video.getLinkYoutubeUrl()}
        onClick={onClickHandler}
      >
        <span className="flex">
          <img src={video.getDefaultThumbnailUrl()} />

          <span className="flex flex-col">
            <span className="video-title">{video.getTitle()}</span>
            <VideoDuration duration={video.getVideoDuration()} />
          </span>
        </span>
      </a>
    </div>
  );
};

export default YoutubeVideoListItem;
